import { Translation } from 'hooks/useTranslation/useTranslation';
import { FilterChip } from 'v2/components/SearchAndFilters/SearchAndFilters';
import {
  DevicesFilterState,
  FilterBatteryStatusState,
  FilterDeviceGroupsState,
  FilterDeviceTypeState,
  FilterOfficeModeState
} from './deviceFilterTypes';

interface Params {
  translation: Translation;
  filters: DevicesFilterState;
}

export const createDeviceFilterChips = ({ translation, filters }: Params): FilterChip[] => {
  const { filterDeviceGroups, filterDeviceType, filterBatteryStatus, filterOfficeMode } = filters.filter;
  const { setFilterDeviceGroups, setFilterDeviceType, setFilterBatteryStatus, setFilterOfficeMode } = filters.setters;

  const deviceTypeLabels: Record<keyof FilterDeviceTypeState, string> = {
    reader: translation.reader,
    controller: translation.controller,
    handle: translation.handle,
    swingHandle: translation.swing_handle,
    cylinder: translation.cylinder,
    locker: translation.locker
  };

  const batteryStatusLabels: Record<keyof FilterBatteryStatusState, string> = {
    unknown: translation.unknown,
    empty: translation.empty,
    critical: translation.critical,
    low: translation.low,
    full: translation.full
  };

  return [
    ...(filterDeviceGroups !== null
      ? [
          {
            label:
              filterDeviceGroups === FilterDeviceGroupsState.Assigned ? translation.assigned : translation.not_assigned,
            onDelete: () => setFilterDeviceGroups(null)
          }
        ]
      : []),
    ...(Object.keys(filterDeviceType) as (keyof FilterDeviceTypeState)[])
      .filter((key) => filterDeviceType[key])
      .map((key) => ({
        label: deviceTypeLabels[key],
        onDelete: () => setFilterDeviceType((current) => ({ ...current, [key]: false }))
      })),
    ...(Object.keys(filterBatteryStatus) as (keyof FilterBatteryStatusState)[])
      .filter((key) => filterBatteryStatus[key])
      .map((key) => ({
        label: batteryStatusLabels[key],
        onDelete: () => setFilterBatteryStatus((current) => ({ ...current, [key]: false }))
      })),
    ...(filterOfficeMode !== null
      ? [
          {
            label:
              filterOfficeMode === FilterOfficeModeState.HasOfficeMode
                ? translation.has_office_mode
                : translation.no_office_mode,
            onDelete: () => setFilterOfficeMode(null)
          }
        ]
      : [])
  ];
};
